module.exports = __webpack_public_path__ + "img/2.7aba1b67.jpg";